var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ParticipantsList',{attrs:{"items":_vm.participantsList,"loading":!_vm.participantsInitialised}})}
var staticRenderFns = []

export { render, staticRenderFns }